import React, { useState, useEffect } from "react";
import { FormControl, MenuItem, Select, InputLabel } from '@mui/material';
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { InputAutocomplete } from 'src/mtska-frontend-app-component';
import JSONPretty from 'react-json-pretty';
import { useSettingContextInComponent, useSettingsContext } from "src/mtska-frontend-app-scaffolding";

const Filters = ({ dataProviderName, filters:defaultFilters, style }) => {
    const { t } = useTranslation();
    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const { settingsLoaded, addFilter } = useSettingsContext(dataProviderName, defaultFilters)

    const [advertisingSourceName, setAdvertisingSourceName] = useState();
    const [areaName, setAreaName] = useState();
    const [selectedValueYear, setSelectedValueYear] = useState();
    const [selectedValueLegalEntity, setSelectedValueLegalEntity] = useState();

    useEffect(() => {
        if (settingsLoaded == false) return;

        setAdvertisingSourceName(filterModel?.items?.find(f => f.field === '_related_source_name')?.value || null);
        setAreaName(filterModel?.items?.find(f => f.field === '_related_area_name')?.value || null);
        setSelectedValueYear(filterModel?.items?.find(f => f.field === 'year')?.value || null);
        setSelectedValueLegalEntity(filterModel?.items?.find(f => f.field === '_related_legalEntity_name')?.value || null);
    }, [filterModel])

    return (drawable &&
        <>
            {/* filterModel in Filters
            <JSONPretty data={filterModel} className="json-wrapper" style={{ overflow: 'scroll', fontSize: '10px' }}></JSONPretty> */}

            <Box className="dashboard-section-filters" sx={style}>
 
                <FormControl style={{ flex: '1' }} size="small">
                    <InputLabel
                        id="year-label"
                        sx={{
                            backgroundColor: 'white',
                            px: 0.5,
                        }}
                        shrink={selectedValueYear ? true : false}
                    >
                        {t("year")}
                    </InputLabel>
                    <Select
                        name="year"
                        value={selectedValueYear}
                        labelId="year-label"
                        onChange={(e) => {
                            setSelectedValueYear(e.target.value);
                            addFilter('year', e.target.value, 'equals');
                        }}
                    >
                        <MenuItem value="">{t("select")}</MenuItem>
                        <MenuItem value="2026">{t("2026")}</MenuItem>
                        <MenuItem value="2025">{t("2025")}</MenuItem>
                        <MenuItem value="2024">{t("2024")}</MenuItem>
                    </Select>
                </FormControl>

                <FormControl style={{ flex: '1' }} size="small">
                    <InputLabel
                        id="le-label"
                        sx={{
                            backgroundColor: 'white',
                            px: 0.5,
                        }}
                        shrink={selectedValueLegalEntity ? true : false}
                    >
                        {t("legalEntity_name")}
                    </InputLabel>
                    <Select
                        name="_related_legalEntity_name"
                        value={selectedValueLegalEntity}
                        labelId="le-label"
                        onChange={(e) => {
                            setSelectedValueLegalEntity(e.target.value);
                            addFilter('_related_legalEntity_name', e.target.value, 'equals');
                        }}
                    >
                        <MenuItem value="">{t("select")}</MenuItem>
                        <MenuItem value="Elletre">{t("Elletre")}</MenuItem>
                        <MenuItem value="Levante">{t("Levante")}</MenuItem>
                        <MenuItem value="QuattroK">{t("QuattroK")}</MenuItem>
                    </Select>
                </FormControl>

                <InputAutocomplete
                    type="autocomplete"
                    dataProvider="commercials/area/autocomplete"
                    label={t('area')}
                    searchkey={'name'}
                    labelkey={'name'}
                    project={['name']}
                    value={areaName ? { "name": areaName } : null}
                    onChange={(v) => {
                        addFilter('_related_area_name', v?.name);
                    }}
                    style={{ flex: '1' }}
                    size={'small'}
                />

                <InputAutocomplete
                    type="autocomplete"
                    dataProvider="advertisings/source/autocomplete"
                    label={t('source')}
                    searchkey={'name'}
                    labelkey={'name'}
                    project={['name']}
                    value={advertisingSourceName ? { name: advertisingSourceName } : null}
                    onChange={(v) => {
                        addFilter('_related_source_name', v?.name);
                    }}
                    style={{ flex: '1' }}
                    size={'small'}
                />
            </Box>
        </>
    )
}

export default Filters;